import React from 'react';
import { Row } from 'react-bootstrap';
import {
  FormCol,
  FormFilterCard,
  FieldInput,
  FormCol2,
  FormCol3,
  FieldSelectIsActive,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectContributionPeriodGroups,
  FieldSelectContributorGroups,
} from '../../components';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [
          { name: likeObj },
          { addressLine1: likeObj },
          { phoneNumber1: likeObj },
          { vatNumber: likeObj },
          { taxOffice: likeObj },
        ],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.contributorGroupId) {
      where = {
        ...where,
        contributorGroupId: values.contributorGroupId,
      };
    }
    if (values.contributionPeriodGroupId) {
      where = {
        ...where,
        contributionPeriodGroupId: values.contributionPeriodGroupId,
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false }) => {
  //
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    contributorGroupId: initialValues?.contributorGroupId ?? '',
    contributionPeriodGroupId: initialValues?.contributionPeriodGroupId ?? '',
    isActive: initialValues?.isActive ?? '',
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση')}
          type="search"
          disable={disable}
        />
        <FieldSelectContributorGroups as={FormCol3} />
        <FieldSelectContributionPeriodGroups as={FormCol3} />
        <FieldSelectIsActive name="isActive" label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};
